module.exports = __webpack_public_path__ + "img/_ABS9785(1).5b0bcfae.jpg";